window.tenpointShippingTable = window.tenpointShippingTable || {};

tenpointShippingTable.init = function () {
  let shipping_price = null;
  let shipping_json = null;

  this.$table = jQuery('#shipping-table');
  this.$monies = jQuery('#shipping-table span.money');
  this.price = jQuery('#shipping-table').data('price');
  this.weight_g = jQuery('#shipping-table').data('weight');

  /* Fetch shipping rates */
  jQuery
  .ajax({
    url: "https://lf.10point.co.uk/shopify/shipping-zones",
    context: this,
  })
  .done(this.updatePrices)
  .fail(this.handleError);
}

tenpointShippingTable.updatePrices = function(data) {
  const shipping_zones = JSON.parse(data);
  let shipping_price = null;
  
  /* Loop over shipping zone data,
   * updating pricing when a match is found 
   */
  for (var key in shipping_zones) {
    let zone = shipping_zones[key];
    let id = zone.id;
    let price_based = zone.price_based_shipping_rates;
    let weight_based = zone.weight_based_shipping_rates;
    
	/* No rates */
    if (!price_based.length && !weight_based.length) {
      continue;
    }
    
    /* Find the appropriate span.money element for given shipping zone id */
	let $span = this.findMoneySpan(this.$monies, id);
    
    /* No matching span */
    if (!$span) {
      continue;
    }

    /* Find matching price for given weight */
    if (this.weight_g) {
      let weight_kg = this.weight_g / 1000;
      shipping_price = this.findPrice('weight', weight_based, weight_kg);
    }

    /* If nothing was found, check for price based rate */
    if (!shipping_price) {
      let price_pounds = this.price / 100;
      shipping_price = this.findPrice('price', price_based, price_pounds);
    }

    /* Still nothing, return nothing */
    if (!shipping_price) {
      shipping_price = "-";
    } 
    else {
      /* Save GBP to data attribute */
      $span.attr('data-currency-gbp', Currency.formatMoney(shipping_price * 100, Currency.moneyFormats["GBP"].money_format));
      
      /* Convert to selected currency */
      shipping_price = Currency.convert(shipping_price, "GBP", Currency.currentCurrency);
      
      /* Format */
      shipping_price = Currency.formatMoney(shipping_price * 100, Currency.moneyFormats[Currency.currentCurrency].money_format);
    }

    $span.text(shipping_price);
  }
};

tenpointShippingTable.findMoneySpan = function(spans, id) {
  for (let i = 0; i < spans.length; i++) {
    $span = jQuery(spans[i]);
    if ($span.data('id') == id) {
        return $span;
    }
  }
  return null;
};

tenpointShippingTable.findPrice = function(type, rates, value) {
  for (var key in rates) {
    let rate = rates[key];
    if (type === 'weight') {
      let high = rate.weight_high;
      let low = rate.weight_low;
      if (value <= high && value >= low) {
        return rate.price;
      }
    }
    if (type === 'price') {
      let max = rate.max_order_subtotal;
      let min = rate.min_order_subtotal;
      if (max && min) {
        if (value <= max && value >= min) {
          return rate.price;
        }
      }
      if (min && !max) {
        if (value >= min) {
          return rate.price;
        }
      }
      if (max && !min) {
        if (value <= max) {
          return rate.price;
        }
      }
    }
  }
  return null;
};

tenpointShippingTable.handleError = function(xhr) {
  console.error("Error: " + xhr.status + ": " + xhr.responseText);
  
  jQuery.each(this.$monies, function() {
    $(this).removeClass('money').text('-');
  });
  
  this.$table.prepend("<thead><tr><th colspan='2'>Sorry - the shipping rates below cannot be calculated right now</th></tr></thead>");
};

jQuery(document).ready(function() {
  tenpointShippingTable.init()
});
